import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINT_SIZES } from 'tradera-constants/breakpoints';

const useIsDesktop = () =>
    useMediaQuery({
        minWidth: BREAKPOINT_SIZES.LG.min,
        maxWidth: BREAKPOINT_SIZES.XL.max
    });

export const withIsDesktop = WrappedComponent => {
    const WithIsDesktop = props => {
        const isDesktop = useIsDesktop();
        return <WrappedComponent isDesktop={isDesktop} {...props} />;
    };

    WithIsDesktop.displayName = `withIsDesktop(${WrappedComponent.displayName ||
        WrappedComponent.name}`;

    return WithIsDesktop;
};

export default useIsDesktop;
